var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.738,
    height: 8.59,
    viewBox: "906.632 243.769 10.738 8.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.162 245.11h-4.15l-1.2-1c-.265-.22-.6-.341-.945-.341h-2.027a1.21 1.21 0 0 0-1.208 1.208v6.174a1.21 1.21 0 0 0 1.208 1.208h8.322a1.21 1.21 0 0 0 1.208-1.208v-4.832a1.21 1.21 0 0 0-1.208-1.208Z",
    fill: "#b9bdc3",
    fillRule: "evenodd",
    "data-name": "icons8-music_folder"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.dccaa7e869af486225954bce76fb13d5.svg";
export { ForwardRef as ReactComponent };